export function transactionShowTabularColumn() {
  return [
    {
      name: 'id',
      title: 'شماره تراکنش'
    },
    {
      name: 'status',
      title: 'وضعیت'
    },
    {
      name: 'from_wallet',
      title: 'از کیف پول'
    },
    {
      name: 'transactional_type',
      title: 'مدل تراکنش'
    },
    {
      name: 'transactional_id',
      title: 'شماره مدل'
    },
    {
      name: 'created_at',
      title: 'تاریخ ایجاد'
    },
    {
      name: 'paid_at',
      title: 'تاریخ پرداخت'
    }
  ]
}